import { createReducer } from 'redux-act';

import {
  WEB_MENUS_FETCH,
  WEB_MENUS_FETCH_DATA_SUCCESS,
  WEB_MENUS_FETCH_DATA_FAIL,
  WEB_MENUS_DELETE_INIT,
  WEB_MENUS_DELETE_SUCCESS,
  WEB_MENUS_DELETE_FAIL,
  WEB_MENUS_CLEAR_DATA,
  WEB_MENUS_CREATE_INIT,
  WEB_MENUS_CREATE_SUCCESS,
  WEB_MENUS_CREATE_FAIL,
  WEB_MENUS_MODIFY_INIT,
  WEB_MENUS_MODIFY_SUCCESS,
  WEB_MENUS_MODIFY_FAIL,
  WEB_MENUS_CLEAN_UP,
  WEB_MENUS_CLEAR_DATA_LOGOUT,
  SET_WEB_MENUS,
} from 'state/actions/webMenus';

const initialState = {
  list: [],
  loading: false,
  error: null,
  success: false,
  deleted: false,
  updated: false,
};

export const webMenusReducer = createReducer(
  {
    [WEB_MENUS_FETCH]: () => ({
      ...initialState,
      loading: true,
    }),
    [WEB_MENUS_FETCH_DATA_SUCCESS]: (state, payload) => {
      return {
        ...state,
        list: payload.WEB_MENUS.data || [],
        loading: false,
        error: null,
      };
    },
    [WEB_MENUS_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_MENUS_DELETE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [WEB_MENUS_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((elem) => elem._id !== payload.id),
      loading: false,
      error: null,
      deleted: true,
    }),
    [WEB_MENUS_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_MENUS_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [WEB_MENUS_CREATE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [WEB_MENUS_CREATE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.concat(payload.informationCategory),
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [WEB_MENUS_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_MENUS_MODIFY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [WEB_MENUS_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      list: !state.list
        ? []
        : state.list.map((elem) => {
            if (elem._id === payload.id) {
              return {
                _id: payload.id,
                name: payload.informationCategory.name,
                description: payload.informationCategory.description,
                siteId: payload.informationCategory.siteId,
                modifiedAt: new Date().toDateString(),
                modifiedBy: payload.informationCategory.modifiedBy,
              };
            }
            return elem;
          }),
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [WEB_MENUS_MODIFY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_MENUS_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false,
      updated: false,
    }),
    [WEB_MENUS_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
    [SET_WEB_MENUS]: (state, payload) => ({
      ...state,
      category: payload.data,
    }),
  },
  initialState
);
